import zuzhi from "@/assets/icon/zuzhi.png";
import sucai from "@/assets/icon/sucai.png";
import qiye from "@/assets/icon/qiye.png";
import post from "@/assets/icon/post.png";
import classImg from "@/assets/icon/class.png";
import sjzy from "@/assets/icon/sjzy.png";
import jxjg from "@/assets/icon/jxjg.png";
import rxcp from "@/assets/icon/rxcp.png";
import wjzy from "@/assets/icon/wjzy.png";
import qxgl from "@/assets/icon/qxgl.png";
import mbgl from "@/assets/icon/mbgl.png";
import qyzq from "@/assets/icon/qyzq.png";
import khgl from "@/assets/icon/khgl.png";

import banbenfuwu from "@/assets/icon/banbenfuwu.png";

let host = "";
if (process.env.NODE_ENV === "development") {
  // host = "/devApi/";
  host = "http://192.168.1.41:9900/";
  // host = "http://47.99.84.183:9900/";
} else if (process.env.NODE_ENV === "production") {
  host = "https://admin.learning.com.cn/api/";
} else if (process.env.NODE_ENV === "staging") {
  host = "http://xiangxue-wap.learning.com.cn/api/";
}

export default {
  host,
  //考试模板地址
  examTemplateAddress: "https://odm.learning.com.cn/moban/%E8%80%83%E9%A2%98%E6%96%87%E4%BB%B6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-v4.xlsx",
  examExcelUrl: "https://odm.learning.com.cn/moban/%E8%80%83%E9%A2%98%E6%96%87%E4%BB%B6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-v5.xlsx",
  postEngineExcelUrl:
    "https://odm-business.oss-cn-shanghai.aliyuncs.com/moban/%E5%B2%97%E4%BD%8D%E5%BC%95%E6%93%8E%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-v2.xlsx",
  cooKey: "Authorization",
  pageSizes: [10, 20, 50, 100],
  title: "小安学堂",
  subTitle: "运营管理后台",
  keyStr: "cd59cec85ab8a4256c903aaf1bb3baf5",
  iv: "9kw10539wmsr8ukd",
  version: "1.0.0",
  imageSize: 10, //图片的最大尺寸
  videoSize: 500, //视频的最大尺寸
  imageQuality: 0.6, //图片压缩的画质最大1
  passText: "您的订单已确认，相关课程或服务已经开通，请前往相关栏目查看，如有任何疑问请咨询在线客服，谢谢!",
  noText: "您的订单未被确认，请仔细查看支付信息是否正确，如有任何疑问请咨询在线客服，谢谢!",
  difficultyList: [
    {
      name: "简单",
      value: 1,
    },
    {
      name: "中等",
      value: 2,
    },
    {
      name: "困难",
      value: 3,
    },
  ],
  qusTypeList: [
    {
      name: "单选题",
      value: "oneChoice",
    },
    {
      name: "多选题",
      value: "checkBox",
    },
    {
      name: "判断题",
      value: "judge",
    },
    {
      name: "填空题",
      value: "fillBlank",
    },
  ],
  orderType: [
    {
      label: "全部类型",
      value: -1,
    },
    {
      label: "课程",
      value: 0,
    },
    {
      label: "引擎",
      value: 1,
    },
    {
      label: "服务",
      value: 2,
    },
    {
      label: "学习项目",
      value: 3,
    }, {
      label: "课程套餐",
      value: 4,
    }, {
      label: "企业会员",
      value: 5,
    }
  ],
  enterPriceStatus: [
    {
      label: "全部企业状态",
      value: -1,
    },
    {
      label: "正常企业状态",
      value: 0,
    },
    {
      label: "冻结企业状态",
      value: 1,
    },
  ],
  goodsStatus: [
    {
      label: "全部",
      value: -1,
    },
    {
      label: "待执行",
      value: 0,
    },
    {
      label: "正执行",
      value: 1,
    },
    {
      label: "已过期",
      value: 2,
    },
    {
      label: "未开通",
      value: 3,
    },
  ],
  importanceList: [
    {
      label: "未设",
      value: 0,
    },
    {
      label: "1",
      value: 1,
    },
    {
      label: "2",
      value: 2,
    },
    {
      label: "3",
      value: 3,
    },
    {
      label: "4",
      value: 4,
    },
    {
      label: "5",
      value: 5,
    },
    {
      label: "6",
      value: 6,
    },
    {
      label: "7",
      value: 7,
    },
    {
      label: "8",
      value: 8,
    },
    {
      label: "9",
      value: 9,
    },
    {
      label: "10",
      value: 10,
    },
  ],
  postLevelList: [
    {
      label: "无级别",
      value: "without",
    },
    {
      label: "助理级",
      value: "assistant",
    },
    {
      label: "初级",
      value: "elementary",
    },
    {
      label: "中级",
      value: "middleRank",
    },
    {
      label: "高级",
      value: "advanced",
    },
    {
      label: "资深",
      value: "senior",
    },
    {
      label: "专家级",
      value: "expert",
    },
    {
      label: "资深专家级",
      value: "seniorExpert",
    },
  ],
  //学历
  educationList: [
    {
      label: "无学历要求",
      value: "without",
    },
    {
      label: "博士",
      value: "doctor",
    },
    {
      label: "硕士",
      value: "master",
    },
    {
      label: "本科",
      value: "regularCollegeCourse",
    },
    {
      label: "大专",
      value: "juniorCollege",
    },
    {
      label: "高中",
      value: "highSchool",
    },
    {
      label: "中专/中技",
      value: "secondary",
    },
    {
      label: "初中及以下",
      value: "juniorHighSchool",
    },
  ],
  //工作年限
  workingYears: [
    {
      label: "无年限要求",
      value: "without",
    },
    {
      label: "在校生/应届生",
      value: "freshGraduate",
    },
    {
      label: "1年以内",
      value: "inAYear",
    },
    {
      label: "1-3年",
      value: "oneThreeYear",
    },
    {
      label: "3-5年",
      value: "threeFiveYear",
    },
    {
      label: "5-10年",
      value: "fiveTenYear",
    },
    {
      label: "10年以上",
      value: "tenAbove",
    },
  ],
  routerList: [
    {
      name: '在岗训练',
      img: classImg,
      subList: [
        {
          name: "绩效指标",
          img: jxjg,
          permissionStr: "ADMIN,CHARGE",
          path: "/performanceResults",
          subList: [],
        },
      ]
    },
    {
      name: "模板管理",
      img: mbgl,
      subList: [
        {
          name: "在线课程模版",
          path: "/template/list",
          isAcv: false,
        },
        {
          name: "学习项目模板",
          path: "/template/learnProject",
          isAcv: false,
        },
      ],
    },
    {
      name: "素材管理",
      img: sucai,
      subList: [
        {
          name: "图片素材",
          path: "/sourceMaterial/imageManager",
          isAcv: false,
        },
        {
          name: "视频素材",
          path: "/sourceMaterial/videoManager",
          isAcv: false,
        },
        {
          name: "音频素材",
          path: "/sourceMaterial/audioManager",
          isAcv: false,
        },
        {
          name: "文档素材",
          path: "/document/library",
          isAcv: false,
        },
      ],
    },
    {
      name: "调研中心",
      img: wjzy,
      permissionStr: "ADMIN,CHARGE",
      subList: [
        {
          name: "问卷模板",
          path: "/questionManagement",
          isAcv: false,
        },
        {
          name: "评估模版",
          path: "/evaluation",
          isAcv: false,
        },
      ],
    },
    {
      name: "考试中心",
      img: sjzy,
      permissionStr: "ADMIN,CHARGE",
      subList: [
        {
          name: "资源分类",
          path: "/paperResource/resourceClassification",
          isAcv: false,
        },
        {
          name: "题库管理",
          path: "/paperResource/topicPoolManagement",
          isAcv: false,
        },
      ],
    },
    {
      name: "人才发展",
      img: sucai,
      subList: [
        {
          name: "能力项管理",
          path: "/capabilityItemManagement",
          isAcv: false,
        },
        {
          name: "能力库管理",
          path: "/capabilityModelBase",
          isAcv: false,
        },
      ],
    },
    // {
    //   name: "课程管理",
    //   img: classImg,
    //   subList: [
    //     {
    //       name: "课程分类",
    //       path: "/courseClassification",
    //       isAcv: false,
    //     },
    //     {
    //       name: "课程列表",
    //       path: "/courseList",
    //       isAcv: false,
    //     },
    //     {
    //       name: "讲师分类",
    //       path: "/teacherBatch",
    //       isAcv: false,
    //     },
    //     {
    //       name: "讲师列表",
    //       path: "/teacherList",
    //       isAcv: false,
    //     },
    //   ],
    // },
    // {
    //   name: "学习项目管理",
    //   img: classImg,
    //   subList: [

    //   ],
    // },
    {
      name: "订单管理",
      img: qiye,
      subList: [
        {
          name: "企业管理",
          path: "/enterprise/enterprise",
          isAcv: false,
        },
        {
          name: "订单管理",
          path: "/order/orderList",
          isAcv: false,
        },
        {
          name: "版本价格",
          path: "/versionService",
          isAcv: false,
        },
        {
          name: "版本权限",
          path: "/authority",
          isAcv: false,
        },
      ],
    },
    {
      name: "企业专区",
      img: qyzq,
      subList: [
        {
          name: "岗位引擎", //名字
          img: post, //图片
          permissionStr: "ADMIN,CHARGE", //权限别名
          path: "/postEngine", //路由
          subList: [], //子路由
        },
        {
          name: "课程分类",
          path: "/courseClassification",
          isAcv: false,
        },
        // {
        //   name: "课程管理",
        //   path: "/zoneList",
        //   isAcv: false,
        // },
        {
          name: "课程管理",
          path: "/courseList",
          isAcv: false,
        },
        {
          name: "机构分类",
          path: "/enterprise/category",
          isAcv: false,
        },
        {
          name: "机构管理",
          path: "/enterpriseList",
          isAcv: false,
        },
        {
          name: "讲师分类",
          path: "/teacherBatch",
          isAcv: false,
        },
        {
          name: "讲师管理",
          path: "/teacherList",
          isAcv: false,
        },
        {
          name: "学习项目列表",
          path: "/learnProjectList",
          isAcv: false,
        },
        // {
        //   name: "名师管理",
        //   path: "/teacherLists",
        //   isAcv: false,
        // },
      ],
    },
    {
      name: "人效测评",
      img: rxcp,
      subList: [
        {
          name: "个人问卷管理",
          path: "/efficiency/questionnaireManage",
          isAcv: false,
        },
        {
          name: "个人问卷数据",
          path: "/efficiency/questionnaireData",
          isAcv: false,
        },
        // {
        //   name: "个人问卷配置",
        //   path: "/efficiency/questionnaireConfig",
        //   isAcv: false,
        // },
        {
          name: "企业问卷管理",
          path: "/efficiency/companyQuestionnaireManage",
          isAcv: false,
        }
      ]
    },
    {
      name: "客户管理",
      img: khgl,
      subList: [
        {
          name: "试用客户",
          path: "/customerManagement/list",
          isAcv: false,
        },
        {
          name: "生态合作",
          path: "/customerManagement/ecologyList",
          isAcv: false,
        },
      ],
    },
    {
      name: "权限管理",
      img: qxgl,
      subList: [
        {
          name: "管理员账号",
          path: "/jur/jur",
          isAcv: false,
        },
        {
          name: "角色管理",
          path: "/role/role",
          isAcv: false,
        },
      ],
    },

  ], //左边导航栏的路由数据
  pOptions: [
    {
      val: "liveAction",
      content: "讲师入镜",
    },
    {
      val: "liveVideoRecording",
      content: "现场录像",
    },
    {
      val: "ppt",
      content: "PPT+录音",
    },
    {
      val: "audio",
      content: "音频",
    },
    {
      val: "animation",
      content: "动画",
    },
    {
      val: "audioBook",
      content: "有声书",
    },
  ],
  accName: "享学教育科技无锡有限公司",
  recBank: "招商银行无锡分行城北支行",
  bankNumber: "510034567865435",
  acvColor: "#827acf",
};
